"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var PluggableElementBase = function PluggableElementBase(_ref) {
  var name = _ref.name;
  (0, _classCallCheck2.default)(this, PluggableElementBase);
  (0, _defineProperty2.default)(this, "name", '');
  this.name = name;
};

exports.default = PluggableElementBase;